<template>
  <div v-if="productLoading" class="mc-loader"><span class="mc-loader__circle"></span></div>
  <div v-if="productError" class="mc-error" v-html="productError"></div>
  <div v-if="productLoaded" class="mc-detail">
    <div class="mc-product">
      <div class="mc-container">
        <div class="mc-product__gallery mc-gallery">
          <ul class="mc-gallery__labels mc-labels">
            <li v-if="product.is_sale" class="mc-labels__item mc-labels__item--orange">
              %
            </li>
            <li v-if="product.is_new" class="mc-labels__item mc-labels__item--black">
              new
            </li>
          </ul>
              <swiper
                  wrapperTag="ul"
                  :modules="modules"
                  :pagination="{enabled: true, clickable: true, el: '.swiper-pagination1'}"
                  :slides-per-view="1"
                  class="mc-gallery__wrapper swiper"
                  wrapperClass="mc-gallery__list"
              >
                <swiper-slide class="mc-gallery__item" tag="li" v-if="product.video">
                  <div class="mc-gallery__video-container">
                    <video
                        class="mc-gallery__video"
                        :style2="videoStyles"
                        ref="videoElement"
                        :poster="product.more_photo[0]"
                        :src="product.video" playsinline autoplay muted loop
                        preload="auto"
                        @loadeddata="onVideoLoaded"
                        @canplaythrough="onVideoReady"
                        @error="onVideoError"
                    ></video>
                  </div>
                </swiper-slide>
                <swiper-slide v-for="image in product.more_photo"  class="mc-gallery__item" tag="li">
                <picture class="mc-gallery__picture">
                  <img class="mc-gallery__image" :src="image" width="288" height="480" alt="">
                </picture>
                </swiper-slide>
                <template v-slot:container-end><div class="swiper-pagination swiper-pagination1"></div></template>
              </swiper>
        </div>
        <div class="mc-product__summary mc-summary">
          <div class="mc-summary__top">
            <button @click="share" class="mc-icon-link simulated-hover" type="button" aria-label="Поделиться">
              <svg class="mc-icon-link__image" width="25" height="25" viewBox="0 0 25 25">
                <use xlink:href="/assets/svg/sprite.svg#icon-share"></use>
              </svg>
            </button>
            <span class="mc-summary__brand">
                                <img class="mc-summary__brand-image" src="/assets/svg/logo-brand.svg" width="144" height="30" alt="">
                            </span>
            <button
                @click="addToFavorite()"
                :class="{ isFilled: counterFavoriteData && counterFavoriteData.ids && counterFavoriteData.ids.includes(product.id) }"
                class="mc-icon-link simulated-hover" type="button" aria-label="Добавить в избранное">
              <svg class="mc-icon-link__image" width="25" height="25" viewBox="0 0 25 25">
                <use xlink:href="/assets/svg/sprite.svg#icon-favorite"></use>
              </svg>
            </button>
          </div>
          <div class="mc-summary__title">
            {{ product.name }}
          </div>
          <div class="mc-summary__fabric">
            {{ product.material }}
          </div>
          <div class="mc-summary__price mc-price">
                            <span v-if="product.price_old > product.price" class="mc-price__old">
                                {{ product.price_old }} ₽
                            </span>
            <span class="mc-price__current">
                                {{ product.price }} ₽
                            </span>
          </div>
          <div class="mc-summary__best-price">
            <button @click="isOpenBestPrice=true" class="mc-underline-link" type="button">
                                <span class="mc-underline-link__text">
                                    Получить лучшую цену
                                </span>
            </button>
          </div>
        </div>
        <div class="mc-product__sizes">
          <div class="mc-product__sizes-top">
                            <span class="mc-product__sizes-title">
                                Размер
            </span>
            <div class="mc-product__sizes-table" v-if="true">
              <div class="mc-product__sizes-table-links">
                <button @click="showTableSize = true" class="mc-underline-link js-modal-button" data-target="sizesTable" type="button">
                                    <span class="mc-underline-link__text">
                                        Таблица размеров
                                    </span>
                </button>
                <button v-if="hasProductMeasurements" @click="showMeasurements = true" class="mc-underline-link" type="button">
                                    <span class="mc-underline-link__text">
                                        Обмеры изделия
                                    </span>
                </button>
              </div>
              <ProductTableSize :isOpen="showTableSize" @close="showTableSize = false"></ProductTableSize>
              <ProductMeasurements
                  :isOpen="showMeasurements"
                  :measurements="product.measurements"
                  @close="showMeasurements = false"
              ></ProductMeasurements>
            </div>
          </div>
          <div class="mc-sizes">
            <ul class="mc-sizes__list">
              <li v-for="offer in product.offers" class="mc-sizes__item">
                <button @click="currentOffer = offer.id" class="mc-sizes__button js-button-size" :class="{isUnavailable: offer.available != 'Y', isActive: currentOffer == offer.id}" type="button">
                                        <span class="mc-sizes__top">
                                            {{ offer.size }}
                                        </span>
                  <span class="mc-sizes__bottom">
                                            {{ offer.size2 }}
                                        </span>
                </button>
              </li>
            </ul>
          </div>
        </div>
        <div v-if="product.available=='Y'" class="mc-product__availability">
          <button @click="isOpenStore=true" class="mc-underline-link" type="button">
                            <span class="mc-underline-link__text">
                                Наличие в магазинах
                            </span>
          </button>
        </div>
        <div v-if="product.available=='Y'" class="mc-product__one-click-buy">
          <button @click="isOpenOneClick=true" class="mc-underline-link" type="button">
                            <span class="mc-underline-link__text">
                                Купить в один клик
                            </span>
          </button>
        </div>
      </div>
    </div>
    <section v-if="productLoaded && product.color_items.length > 0" class="mc-detail__color-slider mc-color-slider">
      <div class="mc-container">
        <div class="mc-color-slider__title">
          Эта модель в других цветах
        </div>
        <div class="mc-color-slider__wrapper">
              <swiper
                  wrapperTag="ul"
                  :modules="modules"
                  :pagination="false"
                  :slides-per-view="2.1515"
                  :space-between="25"
                  class="mc-color-slider__slider"
                  wrapperClass="mc-color-slider__list">
                <swiper-slide v-for="item in product.color_items" class="mc-color-slider__item" tag="li">
                <router-link class="mc-color-card" :to="'/detail/'+item.id+'/'">
                  <div class="mc-color-card__image-wrapper">
                    <img class="mc-color-card__image" :src="item.picture" width="140" height="234" alt="">
                  </div>
                  <div class="mc-color-card__title">
                    {{ item.color }}
                  </div>
                </router-link>
                </swiper-slide>

              </swiper>
          <div class="swiper-scrollbar"></div>
        </div>
      </div>
    </section>

    <ProductBlock
    v-if="productsStyleLoaded && productsStyle.length > 0"
    :data="{product_type:'two', name:'Стилисты рекомендуют', products: productsStyle}"
    ></ProductBlock>

    <section class="mc-detail__tabs mc-tabs">
      <div class="mc-container">
        <div class="mc-tabs__title">
          Информация
        </div>
        <div class="mc-tabs__button-wrapper">
          <ul class="mc-tabs__list">
            <li class="mc-tabs__item" :class="tabShow==1?'isActive':''" @click="tabShow=1" ref="tab1">
              <button class="mc-tabs__button js-button-tab" data-name="info1" type="button">
                О товаре
              </button>
            </li>
            <li class="mc-tabs__item" :class="tabShow==2?'isActive':''" @click="tabShow=2" ref="tab2">
              <button class="mc-tabs__button js-button-tab" data-name="info2" type="button">
                Описание
              </button>
            </li>
            <li class="mc-tabs__item" :class="tabShow==3?'isActive':''" @click="tabShow=3" ref="tab3">
              <button class="mc-tabs__button js-button-tab" data-name="info3" type="button">
                Уход
              </button>
            </li>
            <li class="mc-tabs__item" :class="tabShow==4?'isActive':''" @click="tabShow=4" ref="tab4">
              <button class="mc-tabs__button js-button-tab" data-name="info4" type="button">
                Доставка и оплата
              </button>
            </li>
            <li class="mc-tabs__item" :class="tabShow==5?'isActive':''" @click="tabShow=5" ref="tab5">
              <button class="mc-tabs__button js-button-tab" data-name="info5" type="button">
                Бонусная система
              </button>
            </li>
            <li v-if="product.declarationlink" class="mc-tabs__item" :class="tabShow==6?'isActive':''" @click="tabShow=6" ref="tab6">
              <button class="mc-tabs__button js-button-tab" data-name="info6" type="button">
                Документы
              </button>
            </li>
            <li class="mc-tabs__glide" :style="tabGlide"></li>
          </ul>
        </div>
        <div class="mc-tabs__body-wrapper">
          <div class="mc-tabs__body" :class="tabShow==1?'isActive':''" id="info1">
            <dl class="mc-info-list">
              <div class="mc-info-list__item" v-if="product.material">
                <dt class="mc-info-list__term">
                  Материал
                </dt>
                <dd class="mc-info-list__definition">
                  {{ product.material }}
                </dd>
              </div>
              <div class="mc-info-list__item" v-if="product.season">
                <dt class="mc-info-list__term">
                  Сезон
                </dt>
                <dd class="mc-info-list__definition">
                  {{ product.season }}
                </dd>
              </div>
              <div class="mc-info-list__item" v-if="product.collection">
                <dt class="mc-info-list__term">
                  Коллекция
                </dt>
                <dd class="mc-info-list__definition">
                  {{ product.collection }}
                </dd>
              </div>
              <div class="mc-info-list__item" v-if="product.color">
                <dt class="mc-info-list__term">
                  Цвет
                </dt>
                <dd class="mc-info-list__definition">
                  {{ product.color }}
                </dd>
              </div>
              <div class="mc-info-list__item" v-if="product.style">
                <dt class="mc-info-list__term">
                  Тема
                </dt>
                <dd class="mc-info-list__definition">
                                        <span class="mc-color">
                                            {{ product.style }}
                                        </span>
                </dd>
              </div>
              <div class="mc-info-list__item" v-if="product.artnumber">
                <dt class="mc-info-list__term">
                  Артикул
                </dt>
                <dd class="mc-info-list__definition">
                  {{ product.artnumber }}
                </dd>
              </div>
            </dl>
          </div>
          <div class="mc-tabs__body" :class="tabShow==2?'isActive':''" id="info2" v-html="product.preview_text">
          </div>
          <div class="mc-tabs__body" :class="tabShow==3?'isActive':''" id="info3">
            <ul class="mc-recommendations">
              <li class="mc-recommendations__item" v-for="item in product.care">
                <img class="mc-recommendations__icon" :src="item.image" width="30" height="30" alt="">
                <p class="mc-recommendations__text">
                  {{item.text}}
                </p>
              </li>
            </ul>
          </div>
          <div class="mc-tabs__body" :class="tabShow==4?'isActive':''" id="info4">
            <ProductDeliveryPayment></ProductDeliveryPayment>
          </div>
          <div class="mc-tabs__body" :class="tabShow==5?'isActive':''" id="info5">
            <ProductBonus></ProductBonus>
          </div>
          <div v-if="product.declarationlink" class="mc-tabs__body" :class="tabShow==6?'isActive':''" id="info6">
            <a :href="product.declarationlink" target="_blank">Декларация соответствия</a>
          </div>
        </div>
      </div>
    </section>

    <ProductBlock
        v-if="productsSimilarLoaded && productsSimilar.length > 0"
        :data="{product_type:'two', name:'Похожие товары', products: productsSimilar}"
    ></ProductBlock>

    <ProductBlock
        v-if="productsViewedLoaded && productsViewed.length > 0"
        :data="{product_type:'two', name:'Просмотренные товары', products: productsViewed}"
    ></ProductBlock>

    <ProductAdvantages></ProductAdvantages>

    <div class="mc-detail__bottom">
      <div class="mc-container">
        <button @click="addToBasket" class="mc-button mc-button--color js-button-add-cart simulated-hover" :class="{isHidden:product.available=='N' || (counterBasketData.ids && counterBasketData.ids.includes(currentOffer))}" type="button">
                        <span class="mc-button__text">
                            Добавить в корзину
                        </span>
        </button>
        <router-link to="/basket/" v-if="product.available=='Y' && counterBasketData.ids && counterBasketData.ids.includes(currentOffer)" class="mc-button js-button-cart-added simulated-hover" type="button">
                        <span class="mc-button__text">
                            Перейти в корзину
                        </span>
        </router-link>
        <button @click="isOpenNotifyAvailable=true" class="mc-button js-button-notify simulated-hover" :class="{isHidden:product.available=='Y'}" type="button">
                        <span class="mc-button__text">
                            Сообщить о поступлении
                        </span>
        </button>
        <button class="mc-button js-button-list simulated-hover isHidden" type="button">
                        <span class="mc-button__text">
                            Перейти в лист ожидания
                        </span>
        </button>
      </div>
    </div>
  </div>

  <ProductBestPrice :isOpen="isOpenBestPrice" @close="isOpenBestPrice=false"></ProductBestPrice>
  <ProductOneClick :isOpen="isOpenOneClick" @close="isOpenOneClick=false" :key="currentOffer" :id="currentOffer"></ProductOneClick>
  <ProductNotifyAvailable :isOpen="isOpenNotifyAvailable" :id="currentOffer" @close="isOpenNotifyAvailable=false" :key="currentOffer"></ProductNotifyAvailable>
  <ProductStore v-if="isOpenStore" :key="currentOffer" :id="currentOffer" :isOpen="isOpenStore" @close="isOpenStore=false"></ProductStore>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import { Swiper, SwiperSlide } from 'swiper/vue';
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/scrollbar';
import 'swiper/css/navigation';
import { Pagination, Navigation, Scrollbar } from 'swiper';
import ProductBlock from './blocks/ProductBlock.vue';
import ProductAdvantages from './blocks/ProductAdvantages.vue';
import ProductDeliveryPayment from './blocks/ProductDeliveryPayment.vue';
import ProductBonus from './blocks/ProductBonus.vue';
import ProductTableSize from './blocks/ProductTableSize.vue';
import ProductBestPrice from './blocks/ProductBestPrice.vue';
import ProductOneClick from './blocks/ProductOneClick.vue';
import ProductNotifyAvailable from './blocks/ProductNotifyAvailable.vue';
import ProductStore from './blocks/ProductStore.vue';
import ProductMeasurements from './blocks/ProductMeasurements.vue';

export default {
    beforeRouteLeave(to, from) {
        //if (to.name != 'login')
        //  this.$store.dispatch('unLoader');
    },
    created() {
      this.load();
    },
    computed: {
      ...mapGetters([
        'product',
        'productLoading',
        'productError',
        'productLoaded',
          'productsStyle',
          'productsStyleLoaded',
        'productsSimilar',
        'productsSimilarLoaded',
        'productsViewed',
        'productsViewedLoaded',
        'counterFavoriteData',
        'counterBasketData'
      ]),
      hasProductMeasurements() {
        return !!(
            this.product
            && this.product.measurements
            && Array.isArray(this.product.measurements.columns)
            && Array.isArray(this.product.measurements.rows)
            && this.product.measurements.columns.length > 0
            && this.product.measurements.rows.length > 0
        );
      }
    },
    mounted() {

    },
    methods: {
      ...mapActions([
        'fetchProduct',
        'fetchProductsStyle',
        'fetchProductsSimilar',
        'fetchProductsViewed'
      ]),
      async load() {

        this.$store.commit('UNSET_PRODUCT');
        this.$store.commit('UNSET_PRODUCTS_STYLE', []);
        this.$store.commit('UNSET_PRODUCTS_SIMILAR', []);
        this.$store.commit('UNSET_PRODUCTS_VIEWED', []);
        await this.fetchProduct(this.$route.params.id);
        if (this.productLoaded) {
          this.$route.meta.prev = '/category/' + this.product.section_id + '/';
          this.currentOffer = this.getFirstAvailableOffer();
          this.fetchProductsStyle(this.$route.params.id);
          this.fetchProductsSimilar(this.$route.params.id);
          this.fetchProductsViewed();
          setTimeout(() => {
            this.setTabActive(1);
          }, 500)
        }
      },
      getFirstAvailableOffer() {
        // Сначала проверяем текущий офер
        const currentOfferId = this.product.currentOffer;
        const currentOfferData = this.product.offers.find(offer => offer.id === currentOfferId);

        // Если текущий офер доступен, возвращаем его
        if (currentOfferData && currentOfferData.available === 'Y') {
          return currentOfferId;
        }

        // Иначе ищем первый доступный офер
        const firstAvailable = this.product.offers.find(offer => offer.available === 'Y');

        // Возвращаем первый доступный или текущий, если доступных нет
        return firstAvailable ? firstAvailable.id : currentOfferId;
      },
      addToFavorite() {
        this.$store.dispatch('addToFavorite', this.product.id);
      },
      addToBasket() {
        this.$store.dispatch('addToBasket', {productId:this.currentOffer, quantity: 1});
      },
      share() {
        if ('share' in navigator) {
          navigator
              .share({
                title: this.product.name,
                url: this.product.url,
              })
              .then(() => {
                console.log('Callback after sharing');
              })
              .catch(console.error);
        } else {
          console.log('provide fallback share');
        }
      },
      getPositionRelativeToParent(element) {
        var parent = element.parentElement;
        var parentRect = parent === null || parent === void 0 ? void 0 : parent.getBoundingClientRect();
        var elementRect = element.getBoundingClientRect();
        return {
          left: elementRect.left - parentRect.left,
          top: elementRect.top - parentRect.top
        };
      },
      setTabActive(newValue) {
        let tabItem = this.$refs['tab'+newValue];
        let relativePosition = this.getPositionRelativeToParent(tabItem);
        this.tabGlide.left = relativePosition.left + "px";
        this.tabGlide.top = relativePosition.top + "px";
        this.tabGlide.width = tabItem.offsetWidth + "px";
        this.tabGlide.height = tabItem.offsetHeight + "px";
      },
      onVideoLoaded() {
        console.log('Первые кадры видео загружены');
        this.showVideo();
      },

      onVideoReady() {
        console.log('Видео полностью готово к воспроизведению');
        this.showVideo();
      },

      onVideoError(error) {
        console.error('Ошибка загрузки видео:', error);
        this.videoError = true;
        // Все равно показываем интерфейс, но без видео
        this.showVideo();
      },

      showVideo() {
        if (!this.videoLoaded) {
          this.videoLoaded = true;
          this.videoStyles.opacity = 1;

          // Пытаемся запустить воспроизведение
          this.$nextTick(() => {
            this.playVideo();
          });
        }
      },
      async playVideo() {
        try {
          if (this.$refs.videoElement) {
            await this.$refs.videoElement.play();
          }
        } catch (error) {
          console.log('Автовоспроизведение заблокировано:', error);
        }
      }
    },
  watch: {
      tabShow(newValue, oldValue) {
        this.setTabActive(newValue);
      },
      '$route'() {
        this.load();
      },
      currentOffer(newValue, oldValue) {
        for (let i in this.product.offers) {
          if (this.product.offers[i].id == newValue) {
            this.product.price = this.product.offers[i].price;
            this.product.price_old = this.product.offers[i].price_old;
            this.product.available = this.product.offers[i].available;
            this.product.quantity = this.product.offers[i].quantity;
            break;
          }
        }
      }
  },
    data: () => ({
      modules: [Navigation, Scrollbar,Pagination],
      tabShow: 1,
      tabGlide: {
        left: 0,
        top: 0,
        width: 0,
        height: 0
      },
      currentOffer: 0,
      showTableSize: false,
      showMeasurements: false,
      isOpenBestPrice: false,
      isOpenStore: false,
      isOpenOneClick: false,
      isOpenNotifyAvailable: false,
      videoLoaded: false,
      videoError: false,
      videoStyles: {
        opacity: 0,
        transition: 'opacity 1s ease-in-out'
      }
    }),
    components: {
      Swiper,
      SwiperSlide,
      ProductBlock,
      ProductAdvantages,
      ProductDeliveryPayment,
      ProductBonus,
      ProductTableSize,
      ProductBestPrice,
      ProductStore,
      ProductNotifyAvailable,
      ProductOneClick,
      ProductMeasurements
    }
}
</script>

<style scoped>
.mc-product__sizes-table-links {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
}
</style>

